import React from 'react';
import AnimatedPage from '../../components/AnimatedPage';
import Img from '../../assets/images/Digibank.png';
import {motion} from 'framer-motion';
import {BackButton} from '../../components/BackButton';

const Digibank = () => {
  return (
    <AnimatedPage animationType="fade">
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BackButton />
        <motion.img
          src={Img}
          alt="Digibank"
          initial={{opacity: 0, scale: 0.8, x: '-50%', y: '-50%'}}
          animate={{opacity: 1, scale: 1, x: '-50%', y: '-50%'}}
          transition={{delay: 0.3, duration: 0.7, ease: 'easeOut'}}
          style={{
            position: 'absolute',
            top: '55%',
            left: '50%',
            width: '99%',
            height: '98%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </div>
    </AnimatedPage>
  );
};

export default Digibank;
